/*
 * Action Types
 */
export enum AttendanceTypes {
  // Connection
  INIT_WEBSOCKET_CHANNEL = '@attendance/INIT_WEBSOCKET_CHANNEL',
  CLOSE_WEBSOCKET_CHANNEL = '@attendance/CLOSE_WEBSOCKET_CHANNEL',

  // Single Attendance Messages
  GET_MESSAGES_REQUEST = '@attendance/GET_MESSAGES_REQUEST',
  GET_MESSAGES_SUCCESS = '@attendance/GET_MESSAGES_SUCCESS',
  GET_MESSAGES_FAILURE = '@attendance/GET_MESSAGES_FAILURE',

  // Older Messages page (v2 pagination)
  GET_OLDER_MESSAGES_REQUEST = '@attendance/GET_OLDER_MESSAGES_REQUEST',
  GET_OLDER_MESSAGES_SUCCESS = '@attendance/GET_OLDER_MESSAGES_SUCCESS',
  GET_OLDER_MESSAGES_FAILURE = '@attendance/GET_OLDER_MESSAGES_FAILURE',

  // List opened users
  LIST_OPENED_USERS_REQUEST = '@attendance/LIST_OPENED_USERS_REQUEST',
  LIST_OPENED_USERS_SUCCESS = '@attendance/LIST_OPENED_USERS_SUCCESS',
  LIST_OPENED_USERS_FAILURE = '@attendance/LIST_OPENED_USERS_FAILURE',

  // List closed users
  LIST_CLOSED_USERS_REQUEST = '@attendance/LIST_CLOSED_USERS_REQUEST',
  LIST_CLOSED_USERS_SUCCESS = '@attendance/LIST_CLOSED_USERS_SUCCESS',
  LIST_CLOSED_USERS_FAILURE = '@attendance/LIST_CLOSED_USERS_FAILURE',

  // List chatbot users
  LIST_CHATBOT_USERS_REQUEST = '@attendance/LIST_CHATBOT_USERS_REQUEST',
  LIST_CHATBOT_USERS_SUCCESS = '@attendance/LIST_CHATBOT_USERS_SUCCESS',
  LIST_CHATBOT_USERS_FAILURE = '@attendance/LIST_CHATBOT_USERS_FAILURE',

  // Filter users by name
  FILTER_USERS_BY_NAME_REQUEST = '@attendance/FILTER_USERS_BY_NAME_REQUEST',
  FILTER_USERS_BY_NAME_SUCCESS = '@attendance/FILTER_USERS_BY_NAME_SUCCESS',
  FILTER_USERS_BY_NAME_FAILURE = '@attendance/FILTER_USERS_BY_NAME_FAILURE',

  // Filter users by name
  FILTER_USERS_BY_MESSAGE_REQUEST = '@attendance/FILTER_USERS_BY_MESSAGE_REQUEST',
  FILTER_USERS_BY_MESSAGE_SUCCESS = '@attendance/FILTER_USERS_BY_MESSAGE_SUCCESS',
  FILTER_USERS_BY_MESSAGE_FAILURE = '@attendance/FILTER_USERS_BY_MESSAGE_FAILURE',

  // Filter users by tag
  FILTER_USERS_BY_TAG_REQUEST = '@attendance/FILTER_USERS_BY_TAG_REQUEST',
  FILTER_USERS_BY_TAG_SUCCESS = '@attendance/FILTER_USERS_BY_TAG_SUCCESS',
  FILTER_USERS_BY_TAG_FAILURE = '@attendance/FILTER_USERS_BY_TAG_FAILURE',

  // Filter tags by name
  FILTER_TAG_BY_NAME_REQUEST = '@attendance/FILTER_TAG_BY_NAME_REQUEST',
  FILTER_TAG_BY_NAME_SUCCESS = '@attendance/FILTER_TAG_BY_NAME_SUCCESS',
  FILTER_TAG_BY_NAME_FAILURE = '@attendance/FILTER_TAG_BY_NAME_FAILURE',

  // New Messages
  LOAD_NEW_MESSAGE_REQUEST = '@attendance/LOAD_NEW_MESSAGE_REQUEST',
  LOAD_NEW_MESSAGE_SUCCESS = '@attendance/LOAD_NEW_MESSAGE_SUCCESS',
  LOAD_NEW_MESSAGE_FAILURE = '@attendance/LOAD_NEW_MESSAGE_FAILURE',

  // New User
  LOAD_NEW_USER_REQUEST = '@attendance/LOAD_NEW_USER_REQUEST',
  LOAD_NEW_USER_SUCCESS = '@attendance/LOAD_NEW_USER_SUCCESS',
  LOAD_NEW_USER_FAILURE = '@attendance/LOAD_NEW_USER_FAILURE',

  // Selected conversation status
  LOAD_CONVERSATION_STATUS_SUCCESS = '@attendance/LOAD_CONVERSATION_STATUS_SUCCESS',

  // Room
  LOAD_ROOM_SUCCESS = '@attendance/LOAD_ROOM_SUCCESS',

  // Subscribe
  LOAD_SUBSCRIBE_SUCCESS = '@attendance/LOAD_SUBSCRIBE_SUCCESS',

  // Attendant List Filter
  LOAD_ATTENDANT_CONVERSATION_LIST_SUCCESS = '@attendance/LOAD_ATTENDANT_CONVERSATION_LIST_SUCCESS',

  // Opened Dialogue Status
  SET_OPENED_STATUS_SUCCESS = '@attendance/SET_OPENED_STATUS_SUCCESS',

  // Dialogue Status
  SET_CLOSED_STATUS_SUCCESS = '@attendance/SET_CLOSED_STATUS_SUCCESS',

  // Visualized Message Status
  SET_VISUALIZED_MESSAGE_STATUS_SUCCESS = '@attendance/SET_VISUALIZED_MESSAGE_STATUS_SUCCESS',

  // Visualized Message Status
  SET_ATTENDANT_MESSAGE_STATUS_SUCCESS = '@attendance/SET_ATTENDANT_MESSAGE_STATUS_SUCCESS',

  // Update user
  UPDATE_USER_REQUEST = '@attendance/UPDATE_USER_REQUEST',
  UPDATE_USER_SUCCESS = '@attendance/UPDATE_USER_SUCCESS',
  UPDATE_USER_FAILURE = '@attendance/UPDATE_USER_FAILURE',

  // Typing Status
  SET_TYPING_STATUS_REQUEST = '@attendance/SET_TYPING_STATUS_REQUEST',
  SET_TYPING_STATUS_SUCCESS = '@attendance/SET_TYPING_STATUS_SUCCESS',
  SET_TYPING_STATUS_FAILURE = '@attendance/SET_TYPING_STATUS_FAILURE',

  // All Tags
  GET_TAG_REQUEST = '@attendance/GET_TAG_REQUEST',
  GET_TAG_SUCCESS = '@attendance/GET_TAG_SUCCESS',
  GET_TAG_FAILURE = '@attendance/GET_TAG_FAILURE',

  LIST_TAGS_REQUEST = '@attendance/LIST_TAGS_REQUEST',
  LIST_TAGS_SUCCESS = '@attendance/LIST_TAGS_SUCCESS',
  LIST_TAGS_FAILURE = '@attendance/LIST_TAGS_FAILURE',

  FILTER_TAGS_REQUEST = '@attendance/FILTER_TAGS_REQUEST',
  FILTER_TAGS_SUCCESS = '@attendance/FILTER_TAGS_SUCCESS',
  FILTER_TAGS_FAILURE = '@attendance/FILTER_TAGS_FAILURE',

  CREATE_TAGS_REQUEST = '@attendance/CREATE_TAGS_REQUEST',
  CREATE_TAGS_SUCCESS = '@attendance/CREATE_TAGS_SUCCESS',
  CREATE_TAGS_FAILURE = '@attendance/CREATE_TAGS_FAILURE',

  UPDATE_TAGS_REQUEST = '@attendance/UPDATE_TAGS_REQUEST',
  UPDATE_TAGS_SUCCESS = '@attendance/UPDATE_TAGS_SUCCESS',
  UPDATE_TAGS_FAILURE = '@attendance/UPDATE_TAGS_FAILURE',

  DELETE_TAGS_REQUEST = '@attendance/DELETE_TAGS_REQUEST',
  DELETE_TAGS_SUCCESS = '@attendance/DELETE_TAGS_SUCCESS',
  DELETE_TAGS_FAILURE = '@attendance/DELETE_TAGS_FAILURE',

  // USer Tags
  LIST_USER_TAGS_REQUEST = '@attendance/LIST_USER_TAGS_REQUEST',
  LIST_USER_TAGS_SUCCESS = '@attendance/LIST_USER_TAGS_SUCCESS',
  LIST_USER_TAGS_FAILURE = '@attendance/LIST_USER_TAGS_FAILURE',

  GET_USER_TAGS_REQUEST = '@attendance/GET_USER_TAGS_REQUEST',
  GET_USER_TAGS_SUCCESS = '@attendance/GET_USER_TAGS_SUCCESS',
  GET_USER_TAGS_FAILURE = '@attendance/GET_USER_TAGS_FAILURE',

  CREATE_USER_TAGS_REQUEST = '@attendance/CREATE_USER_TAGS_REQUEST',
  CREATE_USER_TAGS_SUCCESS = '@attendance/CREATE_USER_TAGS_SUCCESS',
  CREATE_USER_TAGS_FAILURE = '@attendance/CREATE_USER_TAGS_FAILURE',

  UPDATE_USER_TAGS_REQUEST = '@attendance/UPDATE_USER_TAGS_REQUEST',
  UPDATE_USER_TAGS_SUCCESS = '@attendance/UPDATE_USER_TAGS_SUCCESS',
  UPDATE_USER_TAGS_FAILURE = '@attendance/UPDATE_USER_TAGS_FAILURE',

  DELETE_USER_TAGS_REQUEST = '@attendance/DELETE_USER_TAGS_REQUEST',
  DELETE_USER_TAGS_SUCCESS = '@attendance/DELETE_USER_TAGS_SUCCESS',
  DELETE_USER_TAGS_FAILURE = '@attendance/DELETE_USER_TAGS_FAILURE',

  // Message Tag
  LIST_MESSAGE_TAG_REQUEST = '@attendance/LIST_MESSAGE_TAG_REQUEST',
  LIST_MESSAGE_TAG_SUCCESS = '@attendance/LIST_MESSAGE_TAG_SUCCESS',
  LIST_MESSAGE_TAG_FAILURE = '@attendance/LIST_MESSAGE_TAG_FAILURE',

  GET_MESSAGE_TAG_REQUEST = '@attendance/GET_MESSAGE_TAG_REQUEST',
  GET_MESSAGE_TAG_SUCCESS = '@attendance/GET_MESSAGE_TAG_SUCCESS',
  GET_MESSAGE_TAG_FAILURE = '@attendance/GET_MESSAGE_TAG_FAILURE',

  CREATE_MESSAGE_TAG_REQUEST = '@attendance/CREATE_MESSAGE_TAG_REQUEST',
  CREATE_MESSAGE_TAG_SUCCESS = '@attendance/CREATE_MESSAGE_TAG_SUCCESS',
  CREATE_MESSAGE_TAG_FAILURE = '@attendance/CREATE_MESSAGE_TAG_FAILURE',

  UPDATE_MESSAGE_TAG_REQUEST = '@attendance/UPDATE_MESSAGE_TAG_REQUEST',
  UPDATE_MESSAGE_TAG_SUCCESS = '@attendance/UPDATE_MESSAGE_TAG_SUCCESS',
  UPDATE_MESSAGE_TAG_FAILURE = '@attendance/UPDATE_MESSAGE_TAG_FAILURE',

  DELETE_MESSAGE_TAG_REQUEST = '@attendance/DELETE_MESSAGE_TAG_REQUEST',
  DELETE_MESSAGE_TAG_SUCCESS = '@attendance/DELETE_MESSAGE_TAG_SUCCESS',
  DELETE_MESSAGE_TAG_FAILURE = '@attendance/DELETE_MESSAGE_TAG_FAILURE',

  // Qualification
  GET_QUALIFICATION_REQUEST = '@attendance/GET_QUALIFICATION_REQUEST',
  GET_QUALIFICATION_SUCCESS = '@attendance/GET_QUALIFICATION_SUCCESS',
  GET_QUALIFICATION_FAILURE = '@attendance/GET_QUALIFICATION_FAILURE',

  CREATE_QUALIFICATION_REQUEST = '@attendance/CREATE_QUALIFICATION_REQUEST',
  CREATE_QUALIFICATION_SUCCESS = '@attendance/CREATE_QUALIFICATION_SUCCESS',
  CREATE_QUALIFICATION_FAILURE = '@attendance/CREATE_QUALIFICATION_FAILURE',

  DELETE_QUALIFICATION_REQUEST = '@attendance/DELETE_QUALIFICATION_REQUEST',
  DELETE_QUALIFICATION_SUCCESS = '@attendance/DELETE_QUALIFICATION_SUCCESS',
  DELETE_QUALIFICATION_FAILURE = '@attendance/DELETE_QUALIFICATION_FAILURE',

  // Automatic Replies
  LIST_REPLY_REQUEST = '@attendance/LIST_REPLY_REQUEST',
  LIST_REPLY_SUCCESS = '@attendance/LIST_REPLY_SUCCESS',
  LIST_REPLY_FAILURE = '@attendance/LIST_REPLY_FAILURE',

  GET_REPLY_REQUEST = '@attendance/GET_REPLY_REQUEST',
  GET_REPLY_SUCCESS = '@attendance/GET_REPLY_SUCCESS',
  GET_REPLY_FAILURE = '@attendance/GET_REPLY_FAILURE',

  FILTER_REPLY_REQUEST = '@attendance/FILTER_REPLY_REQUEST',
  FILTER_REPLY_SUCCESS = '@attendance/FILTER_REPLY_SUCCESS',
  FILTER_REPLY_FAILURE = '@attendance/FILTER_REPLY_FAILURE',

  CREATE_REPLY_REQUEST = '@attendance/CREATE_REPLY_REQUEST',
  CREATE_REPLY_SUCCESS = '@attendance/CREATE_REPLY_SUCCESS',
  CREATE_REPLY_FAILURE = '@attendance/CREATE_REPLY_FAILURE',

  UPDATE_REPLY_REQUEST = '@attendance/UPDATE_REPLY_REQUEST',
  UPDATE_REPLY_SUCCESS = '@attendance/UPDATE_REPLY_SUCCESS',
  UPDATE_REPLY_FAILURE = '@attendance/UPDATE_REPLY_FAILURE',

  DELETE_REPLY_REQUEST = '@attendance/DELETE_REPLY_REQUEST',
  DELETE_REPLY_SUCCESS = '@attendance/DELETE_REPLY_SUCCESS',
  DELETE_REPLY_FAILURE = '@attendance/DELETE_REPLY_FAILURE',

  // FILE
  GET_FILE_REQUEST = '@attendance/GET_FILE_REQUEST',
  CREATE_FILE_REQUEST = '@attendance/CREATE_FILE_REQUEST',

  // Current User Picture
  GET_CURRENT_USER_PICTURE_REQUEST = '@attendance/GET_CURRENT_USER_PICTURE_REQUEST',
  GET_CURRENT_USER_PICTURE_SUCCESS = '@attendance/GET_CURRENT_USER_PICTURE_SUCCESS',
  GET_CURRENT_USER_PICTURE_FAILURE = '@attendance/GET_CURRENT_USER_PICTURE_FAILURE',

  // Users Picture
  GET_USER_PICTURE_REQUEST = '@attendance/GET_USER_PICTURE_REQUEST',
  GET_USER_PICTURE_SUCCESS = '@attendance/GET_USER_PICTURE_SUCCESS',
  GET_USER_PICTURE_FAILURE = '@attendance/GET_USER_PICTURE_FAILURE',

  // Attendant Picture
  GET_ATTENDANT_PICTURE_REQUEST = '@attendance/GET_ATTENDANT_PICTURE_REQUEST',
  GET_ATTENDANT_PICTURE_SUCCESS = '@attendance/GET_ATTENDANT_PICTURE_SUCCESS',
  GET_ATTENDANT_PICTURE_FAILURE = '@attendance/GET_ATTENDANT_PICTURE_FAILURE',

  CREATE_ATTENDANT_PICTURE_REQUEST = '@attendance/CREATE_ATTENDANT_PICTURE_REQUEST',
  CREATE_ATTENDANT_PICTURE_SUCCESS = '@attendance/CREATE_ATTENDANT_PICTURE_SUCCESS',
  CREATE_ATTENDANT_PICTURE_FAILURE = '@attendance/CREATE_ATTENDANT_PICTURE_FAILURE',

  // Office Hours
  LIST_OFFICE_HOURS_REQUEST = '@attendance/LIST_OFFICE_HOURS_REQUEST',
  LIST_OFFICE_HOURS_SUCCESS = '@attendance/LIST_OFFICE_HOURS_SUCCESS',
  LIST_OFFICE_HOURS_FAILURE = '@attendance/LIST_OFFICE_HOURS_FAILURE',

  GET_OFFICE_HOURS_REQUEST = '@attendance/GET_OFFICE_HOURS_REQUEST',
  GET_OFFICE_HOURS_SUCCESS = '@attendance/GET_OFFICE_HOURS_SUCCESS',
  GET_OFFICE_HOURS_FAILURE = '@attendance/GET_OFFICE_HOURS_FAILURE',

  CREATE_OFFICE_HOURS_REQUEST = '@attendance/CREATE_OFFICE_HOURS_REQUEST',
  CREATE_OFFICE_HOURS_SUCCESS = '@attendance/CREATE_OFFICE_HOURS_SUCCESS',
  CREATE_OFFICE_HOURS_FAILURE = '@attendance/CREATE_OFFICE_HOURS_FAILURE',

  UPDATE_OFFICE_HOURS_REQUEST = '@attendance/UPDATE_OFFICE_HOURS_REQUEST',
  UPDATE_OFFICE_HOURS_SUCCESS = '@attendance/UPDATE_OFFICE_HOURS_SUCCESS',
  UPDATE_OFFICE_HOURS_FAILURE = '@attendance/UPDATE_OFFICE_HOURS_FAILURE',

  DELETE_OFFICE_HOURS_REQUEST = '@attendance/DELETE_OFFICE_HOURS_REQUEST',
  DELETE_OFFICE_HOURS_SUCCESS = '@attendance/DELETE_OFFICE_HOURS_SUCCESS',
  DELETE_OFFICE_HOURS_FAILURE = '@attendance/DELETE_OFFICE_HOURS_FAILURE',

  // Attendants
  LIST_ATTENDANTS_REQUEST = '@attendance/LIST_ATTENDANTS_REQUEST',
  LIST_ATTENDANTS_SUCCESS = '@attendance/LIST_ATTENDANTS_SUCCESS',
  LIST_ATTENDANTS_FAILURE = '@attendance/LIST_ATTENDANTS_FAILURE',

  GET_ATTENDANTS_REQUEST = '@attendance/GET_ATTENDANTS_REQUEST',
  GET_ATTENDANTS_SUCCESS = '@attendance/GET_ATTENDANTS_SUCCESS',
  GET_ATTENDANTS_FAILURE = '@attendance/GET_ATTENDANTS_FAILURE',

  // Attendants
  FILTER_ATTENDANTS_REQUEST = '@attendance/FILTER_ATTENDANTS_REQUEST',
  FILTER_ATTENDANTS_SUCCESS = '@attendance/FILTER_ATTENDANTS_SUCCESS',
  FILTER_ATTENDANTS_FAILURE = '@attendance/FILTER_ATTENDANTS_FAILURE',

  CREATE_ATTENDANTS_REQUEST = '@attendance/CREATE_ATENDANTS_REQUEST',
  CREATE_ATTENDANTS_SUCCESS = '@attendance/CREATE_ATTENDANTS_SUCCESS',
  CREATE_ATTENDANTS_FAILURE = '@attendance/CREATE_ATTENDANTS_FAILURE',

  UPDATE_ATTENDANTS_REQUEST = '@attendance/UPDATE_ATTENDANTS_REQUEST',
  UPDATE_ATTENDANTS_SUCCESS = '@attendance/UPDATE_ATTENDANTS_SUCCESS',
  UPDATE_ATTENDANTS_FAILURE = '@attendance/UPDATE_ATTENDANTS_FAILURE',

  DELETE_ATTENDANTS_REQUEST = '@attendance/DELETE_ATTENDANTS_REQUEST',
  DELETE_ATTENDANTS_SUCCESS = '@attendance/DELETE_ATTENDANTS_SUCCESS',
  DELETE_ATTENDANTS_FAILURE = '@attendance/DELETE_ATTENDANTS_FAILURE',

  // Current Attendant
  GET_CURRENT_ATTENDANT_REQUEST = '@attendance/GET_CURRENT_ATTENDANT_REQUEST',
  GET_CURRENT_ATTENDANT_SUCCESS = '@attendance/GET_CURRENT_ATTENDANT_SUCCESS',
  GET_CURRENT_ATTENDANT_FAILURE = '@attendance/GET_CURRENT_ATTENDANT_FAILURE',

  // Has morre users
  LOAD_HAS_MORE_OPENED_USERS_SUCCESS = '@attendance/LOAD_HAS_MORE_OPENED_USERS_SUCCESS',
  LOAD_HAS_MORE_CLOSED_USERS_SUCCESS = '@attendance/LOAD_HAS_MORE_CLOSED_USERS_SUCCESS',
  LOAD_HAS_MORE_CHATBOT_USERS_SUCCESS = '@attendance/LOAD_HAS_MORE_CHATBOT_USERS_SUCCESS',

  // Token
  GET_TOKEN_REQUEST = '@attendance/GET_TOKEN_REQUEST',
  GET_TOKEN_SUCCESS = '@attendance/GET_TOKEN_SUCCESS',
  GET_TOKEN_FAILURE = '@attendance/GET_TOKEN_FAILURE',

  CREATE_TOKEN_REQUEST = '@attendance/CREATE_TOKEN_REQUEST',
  CREATE_TOKEN_SUCCESS = '@attendance/CREATE_TOKEN_SUCCESS',
  CREATE_TOKEN_FAILURE = '@attendance/CREATE_TOKEN_FAILURE',

  DELETE_TOKEN_REQUEST = '@attendance/DELETE_TOKEN_REQUEST',
  DELETE_TOKEN_SUCCESS = '@attendance/DELETE_TOKEN_SUCCESS',
  DELETE_TOKEN_FAILURE = '@attendance/DELETE_TOKEN_FAILURE',

  // Webhook
  LIST_WEBHOOK_REQUEST = '@attendance/LIST_WEBHOOK_REQUEST',
  LIST_WEBHOOK_SUCCESS = '@attendance/LIST_WEBHOOK_SUCCESS',
  LIST_WEBHOOK_FAILURE = '@attendance/LIST_WEBHOOK_FAILURE',

  FILTER_WEBHOOK_REQUEST = '@attendance/FILTER_WEBHOOK_REQUEST',
  FILTER_WEBHOOK_SUCCESS = '@attendance/FILTER_WEBHOOK_SUCCESS',
  FILTER_WEBHOOK_FAILURE = '@attendance/FILTER_WEBHOOK_FAILURE',

  CREATE_WEBHOOK_REQUEST = '@attendance/CREATE_WEBHOOK_REQUEST',
  CREATE_WEBHOOK_SUCCESS = '@attendance/CREATE_WEBHOOK_SUCCESS',
  CREATE_WEBHOOK_FAILURE = '@attendance/CREATE_WEBHOOK_FAILURE',

  UPDATE_WEBHOOK_REQUEST = '@attendance/UPDATE_WEBHOOK_REQUEST',
  UPDATE_WEBHOOK_SUCCESS = '@attendance/UPDATE_WEBHOOK_SUCCESS',
  UPDATE_WEBHOOK_FAILURE = '@attendance/UPDATE_WEBHOOK_FAILURE',

  DELETE_WEBHOOK_REQUEST = '@attendance/DELETE_WEBHOOK_REQUEST',
  DELETE_WEBHOOK_SUCCESS = '@attendance/DELETE_WEBHOOK_SUCCESS',
  DELETE_WEBHOOK_FAILURE = '@attendance/DELETE_WEBHOOKFAILURE',

  // HeatMap Report
  GET_HEATMAP_REQUEST = '@attendance/GET_HEATMAP_REQUEST',
  GET_HEATMAP_SUCCESS = '@attendance/GET_HEATMAP_SUCCESS',
  GET_HEATMAP_FAILURE = '@attendance/GET_HEATMAP_FAILURE',

  // WordCount Report
  GET_WORDCOUNT_REQUEST = '@attendance/GET_WORDCOUNT_REQUEST',
  GET_WORDCOUNT_SUCCESS = '@attendance/GET_WORDCOUNT_SUCCESS',
  GET_WORDCOUNT_FAILURE = '@attendance/GET_WORDCOUNT_FAILURE',

  // Lines Report
  GET_TAGS_LINES_CHART_REQUEST = '@attendance/GET_TAGS_LINES_CHART_REQUEST',
  GET_TAGS_LINES_CHART_SUCCESS = '@attendance/GET_TAGS_LINES_CHART_SUCCESS',
  GET_TAGS_LINES_CHART_FAILURE = '@attendance/GET_TAGS_LINES_CHART_FAILURE',

  // Rating Report
  GET_RATING_CHART_REQUEST = '@attendance/GET_RATING_CHART_REQUEST',
  GET_RATING_CHART_SUCCESS = '@attendance/GET_RATING_CHART_SUCCESS',
  GET_RATING_CHART_FAILURE = '@attendance/GET_RATING_CHART_FAILURE',

  // Close conversation Report
  GET_CLOSE_CONVERSATION_CHART_REQUEST = '@attendance/GET_RATING_CLOSE_CONVERSATION_REQUEST',
  GET_CLOSE_CONVERSATION_CHART_SUCCESS = '@attendance/GET_RATING_CLOSE_CONVERSATION_SUCCESS',
  GET_CLOSE_CONVERSATION_CHART_FAILURE = '@attendance/GET_RATING_CLOSE_CONVERSATION_FAILURE',

  // First Reply Report
  GET_FIRST_REPLY_CHART_REQUEST = '@attendance/GET_FIRST_REPLY_CHART_REQUEST',
  GET_FIRST_REPLY_CHART_SUCCESS = '@attendance/GET_FIRST_REPLY_CHART_SUCCESS',
  GET_FIRST_REPLY_CHART_FAILURE = '@attendance/GET_FIRST_REPLY_CHART_FAILURE',

  // Conversation Reply Report
  GET_CONVERSATION_REPLY_CHART_REQUEST = '@attendance/GET_CONVERSATION_REPLY_CHART_REQUEST',
  GET_CONVERSATION_REPLY_CHART_SUCCESS = '@attendance/GET_CONVERSATION_REPLY_CHART_SUCCESS',
  GET_CONVERSATION_REPLY_CHART_FAILURE = '@attendance/GET_CONVERSATION_REPLY_CHART_FAILURE',

  // Human and Chatbot Report
  GET_HUMAN_AND_CHATBOT_MESSAGES_CHART_REQUEST = '@attendance/GET_HUMAN_AND_CHATBOT_MESSAGES_CHART_REQUEST',
  GET_HUMAN_AND_CHATBOT_MESSAGES_CHART_SUCCESS = '@attendance/GET_HUMAN_AND_CHATBOT_MESSAGES_CHART_SUCCESS',
  GET_HUMAN_AND_CHATBOT_MESSAGES_CHART_FAILURE = '@attendance/GET_HUMAN_AND_CHATBOT_MESSAGES_CHART_FAILURE',

  // First Reply Report
  GET_FIRST_REPLY_SCATTER_CHART_REQUEST = '@attendance/GET_FIRST_REPLY_SCATTER_CHART_REQUEST',
  GET_FIRST_REPLY_SCATTER_CHART_SUCCESS = '@attendance/GET_FIRST_REPLY_SCATTER_CHART_SUCCESS',
  GET_FIRST_REPLY_SCATTER_CHART_FAILURE = '@attendance/GET_FIRST_REPLY_SCATTER_CHART_FAILURE',
  // Search Message
  LOAD_SEARCH_MESSAGE_ID_SUCCESS = '@attendance/GET_SEARCH_MESSAGE_ID_SUCCESS',
  // Attendance History
  GET_ATTENDANCE_HISTORY_REQUEST = '@attendance/GET_ATTENDANCE_HISTORY_REQUEST',
  GET_ATTENDANCE_HISTORY_SUCCESS = '@attendance/GET_ATTENDANCE_HISTORY_SUCCESS',
  GET_ATTENDANCE_HISTORY_FAILURE = '@attendance/GET_ATTENDANCE_HISTORY_FAILURE',

  // Rating List
  LIST_RATING_REQUEST = '@attendance/LIST_RATING_REQUEST',
  LIST_RATING_SUCCESS = '@attendance/LIST_RATING_SUCCESS',
  LIST_RATING_FAILURE = '@attendance/LIST_RATING_FAILURE',

  // Number of Messages List
  LIST_NUMBER_OF_MESSAGES_REQUEST = '@attendance/LIST_NUMBER_OF_MESSAGES_REQUEST',
  LIST_NUMBER_OF_MESSAGES_SUCCESS = '@attendance/LIST_NUMBER_OF_MESSAGES_SUCCESS',
  LIST_NUMBER_OF_MESSAGES_FAILURE = '@attendance/LIST_NUMBER_OF_MESSAGES_FAILURE',

  // AttendantAssigment
  SET_ATTENDANT_ASSIGNMENT_SUCCESS = '@attendance/SET_ATTENDANT_ASSIGNMENT_SUCCESS',
}

/*
 * Data types
 */
export interface TagInterface {
  ID: string;
  tag: string;
  createdAt?: number;
  updatedAt?: number;
}

export interface MessageInterface {
  // v2: opaque string id ('<13-digit epoch ms>#<random>'), mirrored from the
  // backend's ID field; locally created placeholders also use strings
  id: string;
  ID?: string;
  createdAt?: number;
  message: string;
  username: string;
  type: string;
  messageType: string;
  tags: TagInterface[];
  date: string;
  conversationStatus?: number;
  messageStatus?: string;
  Room?: string;
}

export interface AttendanceInterface {
  Room: string;
  username: string;
  CompanyID?: string;
  conversationStatus: number;
  typingStatus: boolean;
  tags: TagInterface[];
  messages: MessageInterface[];
  userPicture: string;
  attendantOwnerID: string;
  // v2: cursor to fetch the previous (older) messages page; null = no more
  nextCursor?: string | null;
}

export interface UserInterface {
  Room: string;
  username: string;
  conversationStatus: number;
  typingStatus: boolean;
  lastMessage: MessageInterface;
  userPicture?: string;
  attendantOwnerID?: string;
  selectedUser?: boolean;
  updatedAt: number;
  LastEvaluatedKey?: boolean;
  unreadMessages?: number;
}

export interface UserMessageInteface {
  Room: string;
  messageData: MessageInterface;
}

export interface TagRegister {
  data: string;
  room: string;
  messageId?: string;
}

export interface TagsInterface {
  ID: string;
  tag: string;
  userRegister: TagRegister[];
  messageRegister: TagRegister[];
  createdAt?: number;
  updatedAt?: number;
}

export interface ReplyInterface {
  ID: string;
  title: string;
  description: string;
  createdAt?: number;
  updatedAt?: number;
}

interface OfficeHourTime {
  start: number;
  end: number;
}

export interface OfficeHoursInterface {
  ID: string;
  period: string[];
  time: OfficeHourTime[];
  message?: string;
  createdAt?: number;
  updatedAt?: number;
}

export interface AttendantInterface {
  ID: string;
  name: string;
  email: string;
  modules: string[];
  attendantPicture?: string;
  createdAt?: number;
  updatedAt?: number;
}

export interface WebhookInterface {
  ID: string;
  url: string;
  type: string;
  createdAt?: number;
  updatedAt?: number;
}

export interface AttendantChartInterface {
  timeMean: number;
  attendances: any[];
}
export interface AttendanceHistoryInterface {
  start: number;
  end: number;
  user: string;
  room: string;
  attendant: {
    ID: string;
    name: string;
    email: string;
  };
  messages: [
    {
      messageStatus: string;
      date: string;
      messageType: string;
      id: string;
      message: string;
      type: string;
      userID: string;
      username: string;
      tags: string[];
    },
  ];
}

export interface HeatmapInterface {
  start: number;
  end: number;
  data: string;
  // [
  //   {
  //     firstReplyTimes: [
  //       {
  //         startedConversationAt: number;
  //         attendantOwnerID: string;
  //         time: number;
  //       },
  //     ];
  //     createdAt: number;
  //   },
  // ];
}

export interface WordCountInterface {
  text: string;
  count: number;
}

export interface ConversationReplyInterface {
  report: any[];
  users: any[];
  totalWithAnswer: number;
  totalWithNoAnswer: number;
}

export interface HumanAndChatbotChartDataInterface {
  chatbotMessages: number;
  humanMessages: number;
}

export interface RatingInterface {
  attendantId: string;
  CompanyID: string;
  rating: number;
  // v2 ratings carry the string message ID; legacy rows may still be numeric
  messageId: string | number;
  updatedAt: number;
  createdAt: number;
  comment: string;
  ID: string;
  room: string;
}

export interface RatingListInterface {
  count: 0;
  ratingList: RatingInterface[];
}

// Interface used when a new attendant is assinged to a conversation
export interface AttendantAssignmentInterface {
  room: string;
  attendantId: string;
  attendantUsername: string;
  previousAttendantId: string;
  previousAttendantUsername: string;
  isNewAttendant: boolean;
}

export interface ResponseGenerator {
  config?: any;
  data?: any;
  headers?: any;
  request?: any;
  status?: number;
  statusText?: string;
}

export interface NumberOfMessagesInterface {
  attendantName: String;
  attendantMessages: number;
  attendantConversations: number;
}

/*
 * State type
 */
export interface AttendanceState {
  readonly messageData: AttendanceInterface;
  readonly openedUsers: UserInterface[];
  readonly closedUsers: UserInterface[];
  readonly chatbotUsers: UserInterface[];
  readonly filteredUsers: UserInterface[];
  readonly filteredTags: TagInterface[];
  readonly hasMoreOpenedUsers: boolean;
  readonly hasMoreClosedUsers: boolean;
  readonly userMessage: UserMessageInteface;
  readonly Room: string;
  readonly selectedConversationStatus: number;
  readonly subscribe: boolean;
  readonly AttendantConversationList: string;
  readonly Tags: TagsInterface[];
  readonly Tag: TagsInterface;
  readonly Qualification: {};
  readonly Replies: ReplyInterface[];
  readonly Reply: ReplyInterface;
  readonly OfficeHours: OfficeHoursInterface[];
  readonly OfficeHour: OfficeHoursInterface;
  readonly Attendants: AttendantInterface[];
  readonly Attendant: AttendantInterface;
  readonly CurrentAttendant: AttendantInterface;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
  readonly statusCode: number;
  readonly paginationError: boolean;
  readonly Token: string;
  readonly webhookList: WebhookInterface[];
  readonly webhookData: WebhookInterface;
  readonly TagsLinesChartData: any[];
  readonly heatmapData: HeatmapInterface;
  readonly wordCountData: WordCountInterface[];
  readonly RatingChartData: any[];
  readonly CloseConversationChartData: AttendantChartInterface;
  readonly FirstReplyChartData: AttendantChartInterface;
  readonly ConversationReplyChartData: ConversationReplyInterface;
  readonly humanAndChatbotChartData: HumanAndChatbotChartDataInterface;
  readonly FirstReplyScatterChartData: number[];
  readonly searchMessageId: string;
  readonly attendanceHistory: AttendanceHistoryInterface[];
  readonly ratingList: RatingListInterface;
  readonly attendantAssignmentEvent: AttendantAssignmentInterface;
  readonly numberOfMessagesList: NumberOfMessagesInterface[];
}
